export function parseOfferAmount(value) {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const numeric = typeof value === 'string' ? Number(value) : value;
  return Number.isFinite(numeric) ? numeric : null;
}

export function getOfferArtworkId(offer) {
  if (!offer || typeof offer !== 'object') {
    return null;
  }

  return (
    offer.artwork_id
    ?? offer.artwork?.artwork_id
    ?? offer.artwork?._id
    ?? offer.artwork?.id
    ?? null
  );
}

export function getOfferArtworkSlug(offer) {
  if (!offer || typeof offer !== 'object') {
    return null;
  }

  return (
    offer.artwork_slug
    ?? offer.artwork?.slug
    ?? null
  );
}

export function getArtworkIdentityKeys(artworkData) {
  if (!artworkData || typeof artworkData !== 'object') {
    return [];
  }

  const rawKeys = [
    artworkData._id,
    artworkData.id,
    artworkData.artwork_id,
    artworkData.product_artwork?._id,
    artworkData.product_artwork?.id,
    artworkData.product_artwork,
    artworkData.artwork?._id,
    artworkData.artwork?.id,
    artworkData.artwork?.artwork_id,
    artworkData.artwork_data?._id,
    artworkData.artwork_data?.id,
    artworkData.metadata?.artwork_id,
    artworkData.product_metadata?.artwork_id,
    artworkData.slug,
    artworkData.artwork_slug,
    artworkData.product_slug,
  ];

  return [...new Set(
    rawKeys
      .filter((value) => value !== null && value !== undefined && value !== '')
      .map((value) => String(value))
  )];
}

export function isOfferCurrentlyActive(offer, now = Date.now()) {
  if (!offer || typeof offer !== 'object') {
    return false;
  }

  const status = typeof offer.status === 'string' ? offer.status.trim().toLowerCase() : '';
  if (status && status !== 'open') {
    return false;
  }

  if (!offer.expires_at) {
    return true;
  }

  const expiresAt = new Date(offer.expires_at);
  if (Number.isNaN(expiresAt.getTime())) {
    return true;
  }

  return expiresAt.getTime() > now;
}

export function buildActiveOfferMap(offers) {
  if (!Array.isArray(offers) || offers.length === 0) {
    return {};
  }

  const now = Date.now();
  const byArtworkIdentity = {};

  offers.forEach((offer) => {
    if (!isOfferCurrentlyActive(offer, now)) {
      return;
    }

    const identityKeys = [getOfferArtworkId(offer), getOfferArtworkSlug(offer)]
      .filter((value) => value !== null && value !== undefined && value !== '')
      .map((value) => String(value));

    if (identityKeys.length === 0) {
      return;
    }

    identityKeys.forEach((identityKey) => {
      const previous = byArtworkIdentity[identityKey];
      if (!previous) {
        byArtworkIdentity[identityKey] = offer;
        return;
      }

      const previousSentAt = previous?.sent_at ? new Date(previous.sent_at).getTime() : 0;
      const nextSentAt = offer?.sent_at ? new Date(offer.sent_at).getTime() : 0;
      if (nextSentAt >= previousSentAt) {
        byArtworkIdentity[identityKey] = offer;
      }
    });
  });

  return byArtworkIdentity;
}

export function resolveActiveViewerOffer(artworkData, offersByArtworkIdentity = null) {
  if (!artworkData || typeof artworkData !== 'object') {
    return null;
  }

  return (
    artworkData._activeViewerOffer
    ?? artworkData.active_offer
    ?? artworkData.activeOffer
    ?? getArtworkIdentityKeys(artworkData)
      .map((identityKey) => offersByArtworkIdentity?.[identityKey] ?? null)
      .find(Boolean)
    ?? null
  );
}
